<app-monitor-layout #monitorContainer
  [test]="test"
  [testLoading]="testLoading$ | async"
  [patient]="patient"
  [bundle]="bundle"
  [screen]="currentDeviceScreen"
  [isTestDone]="isTestDone"
  [isTestSyncing]="isTestSyncing"
  [deviceLoading]="deviceLoading$ | async"
  [device]="device"
  [batteryPercentage]="batteryPercentage"
  [streamPopupVisible]="streamPopupVisible"
  [isSingleImage]="isSingleImage"
  [isV2Streaming]="isV2Streaming"
  [deviceActionLoading]="deviceActionLoading"
  [isLoading]="isLoading"
  [headsetAlignment]="headsetAlignment"
  (onClose)="close()"
  (onStreamOpen)="openStream($event)"
  (onStreamClose)="closeStream()"
  (onActionClicked)="onActionClicked($event)">

  <div class="monitor_container-column monitor_container-column--limit-height">
    <div class="monitor_graph-box monitor_graph-box--single">
      @if (isTestSyncing) {
        <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
      }
      <div @startList class="monitor_list-container monitor_list-container--has-large-items">
        @for (record of records.slice().reverse(); track record; let i = $index) {
          <div
            @fadeAnimation
            class="monitor_list-item monitor_list-item--large"
            [ngClass]="{'hidden': isRecordHidden(record, i)}">
            @if (record) {
              <ng-container *ngTemplateOutlet="recordView; context: { record: record }"></ng-container>
            } @else {
              <span class="text--blink">{{'syncing' | translate | titlecase}}...</span>
            }
          </div>
        }
        @if (!isLoading && !records?.length) {
          <small>{{ isTestDone ? ('noTestDataReceived' | translate) : ('noTestData' | translate) }}</small>
        }
      </div>
    </div>
  </div>

  <div class="monitor_container-column">
  </div>
</app-monitor-layout>

<ng-template #recordView let-record="record">
  {{record.index}}
  @if (record) {
    <i
      class="fas fa-eye fa-2x"
      [ngClass]="{ 'orange': record.target !== record.target_answer, 'color-primary': record.target === record.target_answer}">
    </i>
  }
  <span
    matTooltip="{{ 'arcsec' | translate | titlecase }}"
    class="pointer">
    {{ record?.arcsec }}
  </span>

  <app-dot-indicator
    [greenPosition]="record.target === record.target_answer ? record.target : null"
    [bluePosition]="record.target !== record.target_answer ? record.target_answer : null"
    [orangePosition]="record.target !== record.target_answer ? record.target : null">
  </app-dot-indicator>

  <span>
    {{ record.target === record.target_answer ? ('seen' | translate) : ('unseen' | translate) }}
  </span>
</ng-template>

